import { DataUploadStatusComponent } from './data-upload-status/data-upload-status.component';
import { FocusedfundComponent } from './focusedfund/focusedfund.component';
import { ScheduleclientComponent } from './scheduleclient/scheduleclient.component';
import { TopSchemeSubAssetwiseComponent } from './top-scheme-sub-assetwise/top-scheme-sub-assetwise.component';
import { BrandingComponent } from './branding/branding.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SchemeDividendComponent } from './scheme-dividend/scheme-dividend.component';
import { SchemeNavComponent } from './scheme-nav/scheme-nav.component';
import { SchemeReturnsComponent } from './scheme-returns/scheme-returns.component';
import { FormsComponent } from './forms/forms.component';
import { SchemePerformanceLumpsumComponent } from './scheme-performance-lumpsum/scheme-performance-lumpsum.component';
import { InvoicegenerateComponent } from './invoicegenerate/invoicegenerate.component';
import { SchemePerformanceCompareComponent } from './scheme-performance-compare/scheme-performance-compare.component';

const routes: Routes = [
  { path: 'scheme-returns', component: SchemeReturnsComponent }, //added by adarsh
  { path: 'scheme-nav', component: SchemeNavComponent }, //added by adarsh
  { path: 'scheme-dividend', component: SchemeDividendComponent }, //added by adarsh
  { path: 'branding', component: BrandingComponent }, //added by adarsh
  { path: 'forms', component: FormsComponent }, //added by Shubham
  {
    path: 'schemeperformancelumpsum',
    component: SchemePerformanceLumpsumComponent
  }, //added by Shubham
  { path: 'Invoice', component: InvoicegenerateComponent },
  {
    path: 'schemeperformancecompare',
    component: SchemePerformanceCompareComponent
  },
  { path: 'scheduleclient', component: ScheduleclientComponent },
  { path: 'focusedfund', component: FocusedfundComponent },
  { path: 'data-upload-status', component: DataUploadStatusComponent }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValueAddServiceRoutingModule {}
